import { combineReducers } from 'redux';
import account from './account';
import contact from './contact';
import event from './event';
import eventAttendance from './event_attendance';
import attendance from './attendance';
import attendances from './attendances';
import events from './events';
import sessions from './sessions';
import stream from './stream';
import hosts from './hosts';

export {
	account,
	attendance,
	contact,
	event,
	eventAttendance,
	events,
	attendances, 
	sessions,
	stream,
	hosts
};

const appReducers = combineReducers({
	account,
	attendance,
	contact,
	event,
	eventAttendance,
	events,
	attendances, 
	sessions,
	stream,
	hosts
});

export default appReducers;